import { cx } from './cx';

export type PointerStatus = 'healthy' | 'rolling' | 'halted' | 'no-pointer';

export interface StatusDotProps {
  status: PointerStatus;
  className?: string;
}

export function StatusDot({ status, className }: StatusDotProps) {
  if (status === 'rolling') {
    return <span className={cx('inline-block w-2 h-2 rounded-full bg-amber-400 pulse-amber', className)} />;
  }
  if (status === 'halted') {
    return <span className={cx('inline-block w-2 h-2 rounded-full bg-red-400', className)} />;
  }
  if (status === 'no-pointer') {
    return <span className={cx('inline-block w-2 h-2 rounded-full bg-slate-600', className)} />;
  }
  return <span className={cx('inline-block w-2 h-2 rounded-full bg-emerald-400', className)} />;
}
